import React from 'react';
import { ChevronDownStyled } from './ChevronInput.styles';

export const ChevronInput = ({ children }) => (
  <div>
    {children}
    <ChevronDownStyled />
  </div>
);
